// URLs shared by ThervuMitra's own UI. Hosts come from MFE_CONFIG (lms.yml).
import { getConfig } from '@edx/frontend-platform';

// Base URL of the course catalog, always ending in "/". Inside the catalog
// MFE itself that is its own public path; elsewhere THERVUMITRA_CATALOG_URL
// (the main domain), falling back to the LMS, which redirects to it.
export function catalogUrl(path = '') {
  const config = getConfig();
  let base;
  if (process.env.APP_ID === 'catalog' && typeof window !== 'undefined') {
    base = window.location.origin + (config.PUBLIC_PATH || '/');
  } else {
    base = config.THERVUMITRA_CATALOG_URL || config.LMS_BASE_URL || '';
  }
  return base.replace(/\/?$/, '/') + path.replace(/^\//, '');
}

export function searchUrl(query) {
  const q = (query || '').trim();
  return catalogUrl(q ? `courses?search_query=${encodeURIComponent(q)}` : 'courses');
}

// Course images from the search index are often LMS-relative.
export function absoluteLmsUrl(url) {
  if (!url) { return url; }
  return /^https?:\/\//.test(url) ? url : `${getConfig().LMS_BASE_URL || ''}${url}`;
}

export function dashboardUrl() {
  const config = getConfig();
  return config.LEARNER_HOME_MICROFRONTEND_URL || `${config.LMS_BASE_URL}/dashboard`;
}
